import styles from 'assets/css/wizard.module.css';

const DotStepper = ({stepLength, activeStep}) => {
  return (
    <div className={styles.dotWrapper}>
      {[...Array(stepLength)].map((_, index) => {
        return (
          <div
            className={index < activeStep ? styles.isActive : styles.notActive}
          />
        );
      })}
    </div>
  );
};

export default DotStepper;
